import { useEffect } from "react"
import { useSearchParams,useNavigate } from 'react-router-dom';
import {useDispatch,useSelector} from 'react-redux';
import {RootState} from '../store';
import {logout,login,IUser} from '../reducer/authentication';
import {httpPost} from '../services/network';
import {API_LOGIN} from '../constants/api';
const useBranchManagerAuth = () => {
    const dispatch=useDispatch();
    const navigate=useNavigate();
    const { isLoggedin } = useSelector(
        (state: RootState) => state.authentication
      );
    const [queryParams] = useSearchParams();
    const {bmLogin}={
        bmLogin:queryParams.get('login_from')==="bm"?true:false
    }
    const handelLogin=()=>{
        httpPost<IUser>(API_LOGIN, {
            mobile: "",
            password: "",
            token:queryParams.get('token')
          }).then((data) => {
            dispatch(login(data.data));
            navigate("/")
          });
    }
    useEffect(() => {
        if(bmLogin===true && isLoggedin===true){
            dispatch(logout());
            handelLogin();
        } else if(bmLogin===true && isLoggedin===false){
            handelLogin()
        }
    }, [])
    return {bmLogin};
}
export default useBranchManagerAuth